export const environment = {
	production: false,
	envName: 'style',
	base_href: '/projects/IBE2018/',
	locale: 'en-US',
	currency: {
		symbol: '€',
		label: 'EUR'
	}
};
